import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import store from './store'
import router from './plugins/router'

/* INTERFACE */
import Vuebar from 'vuebar'
import VueDragscroll from 'vue-dragscroll'
import vuetify from './plugins/vuetify/index'
import { VTextField } from 'vuetify/lib'
import VuetifyDialog from 'vuetify-dialog'
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview'
import VCurrencyField from 'v-currency-field'

/* WEB SOCKET */
import VueWorker from 'vue-worker'
import VueNativeSock from 'vue-native-websocket'

/* PLUGINS */
import VueApexCharts from 'vue-apexcharts'

/* UTILITARIOS */
//import VueHtml2Canvas from 'vue-html2canvas'

/* MODULOS */
import app from '@/app.js'
import defaults from '@/modules/default'
import interfacecfg from '@/modules/interface'

import 'vuetify-dialog/dist/vuetify-dialog.css'
import 'animate.css/animate.min.css'
import './styles/animations.scss'

/*

  "Aquele que habita no esconderijo do Altíssimo, à sombra do Onipotente descansará.
  Direi do Senhor: Ele é o meu Deus, o meu refúgio, a minha fortaleza, e nele confiarei.
  Porque ele te livrará do laço do passarinheiro, e da peste perniciosa.
  Ele te cobrirá com as suas penas, e debaixo das suas asas te confiarás; a sua verdade será o teu escudo e broquel.
  Não terás medo do terror de noite nem da seta que voa de dia,.
  Nem da peste que anda na escuridão, nem da mortandade que assola ao meio-dia.
  Mil cairão ao teu lado, e dez mil à tua direita, mas não chegará a ti.
  Somente com os teus olhos contemplarás, e verás a recompensa dos ímpios.
  Porque tu, ó Senhor, és o meu refúgio. No Altíssimo fizeste a tua habitação.
  Nenhum mal te sucederá, nem praga alguma chegará à tua tenda.
  Porque aos seus anjos dará ordem a teu respeito, para te guardarem em todos os teus caminhos.
  Eles te sustentarão nas suas mãos, para que não tropeces com o teu pé em pedra.
  Pisarás o leão e a cobra; calcarás aos pés o filho do leão e a serpente.
  Porquanto tão encarecidamente me amou, também eu o livrarei; pô-lo-ei em retiro alto, porque conheceu o meu nome.
  Ele me invocará, e eu lhe responderei; estarei com ele na angústia; dela o retirarei, e o glorificarei.
  Fartá-lo-ei com longura de dias, e lhe mostrarei a minha salvação."
  Salmos 91:1-16

*/

Vue.config.productionTip = true
// const threadsQueue = new Worker('./modules/threadsQueue.js', { type: 'module' })


Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  currency: 'BRL',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0
})
Vue.use(Vuebar)
Vue.use(VueDragscroll)
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  },
  property: '$dialog',
  confirm: {
    actions: {
      false: {
        text: defaults.language.confirm.false,
        handle: () => {
          return new Promise((resolve) => {
            setTimeout(resolve, 555)
          })
        }
      },
      true: {
        text: defaults.language.confirm.true,
        color: interfacecfg.colors.confirm.true,
        handle: () => {
          return new Promise((resolve) => {
            setTimeout(resolve, 555)
          })
        }
      }
    },
    icon: 'mdi-delete', // to disable icon just put false
    width: 500
  },
  warning: {},
  error: {},
  prompt: {}
})
Vue.use(VuetifyDraggableTreeview)

/* WEB SOCKET */
Vue.use(VueWorker)
let socketOptions = {
  store: store,
  format: 'json',
  connectManually: app.socket_manual,
  reconnection: true,
  reconnectionDelay: app.socketReconnectionDelay,
  passToStoreHandler: function (eventName, event) {
    if (!eventName.startsWith('SOCKET_')) { return }
    let method = 'commit'
    let target = 'socket/' + eventName.toUpperCase()
    let msg = event
    if (this.format === 'json' && event.data) {
      msg = JSON.parse(event.data)
      if (msg.mutation) {
        target = [msg.namespace || '', msg.mutation].filter((e) => !!e).join('/')
      } else if (msg.action) {
        method = 'dispatch'
        target = [msg.namespace || '', msg.action].filter((e) => !!e).join('/')
      }
    }
    this.store[method](target, msg)
  }
}
Vue.use(VueNativeSock, app.socket_server, socketOptions)

/* PLUGINS */
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

/* UTILITARIOS */
//Vue.use(VueHtml2Canvas)
/* */

var vm = new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')

Vue.config.devtools = interfacecfg.devtools

/* var language = vm.$store.getters.getLanguage */

/* GLOBAL FILTERS */
Vue.filter('phoneMask', str => {
  let cleaned = ('' + str).replace(/\D/g, '')
  return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
})
Vue.filter('cpfMask', str => {
  let cleaned = ('' + str).replace(/\D/g, '')
  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
})
/* */

export default vm
